var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isConnected)?_c('img',{attrs:{"alt":"Connected Icon","src":require("@/assets/img/connected-icon.svg")}}):_c('img',{attrs:{"alt":"Disconnected Icon","src":require("@/assets/img/disconnected-icon.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }